import React from "react";
import mtorWatermark from "../assets/images/back-ground-png-2.png";

const WatermarkImage = () => {
  return (
    <img
      src={mtorWatermark}
      alt="Watermark"
      className="absolute w-full h-full object-contain pointer-events-none"
    />
  );
};

export default WatermarkImage;
